import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const formSubmitEmbedEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-software-form-submit-embed-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
